import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Modal, Button, Badge, Table } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import waringSign from "../../assets/images/warnOmc.png";
import pdfIcon from "../../assets/images/pdf-icon.png";
import { IoEyeOutline } from "react-icons/io5";
import { MdDeleteOutline } from "react-icons/md";
import { FaCheckCircle, FaPlus } from "react-icons/fa";
import { AWSUpload } from "../../Upload/awsupload";

function formatDate(inputDate) {
  const date = new Date(inputDate);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${day}/${month}/${year}`;
}

const ExServicemen = ({
  handelApplicationDetailsChange,
  applicationDetails,
  style,
  closingDate,
}) => {
  const [formData, setFormData] = useState({
    exServiceman: "",
    exServicemanDefenseService: "",
    exServicemanServiceStatus: "",
    exServicemanJoiningDate: "",
    exServicemanRetirementDate: "",
    exServicemanTotalServicePeriod: "",
    // exServicemanAvailedReservation: '',
    exServicemanAppliedForCivilEmployment: "",
    exServicemanDeclaration: false,
    // exServicemanTotalServicePeriodContinuing: "",
    exServicemanTotalServicePeriodContinuingDuration: "",
    exServicemenFiles:[{ file: null, name: "", verified: false }] ,
  });
  const [fieldErrors, setFieldErrors] = useState({});
  const [exServiceModal, setExServiceModal] = useState(false);
  const [showIframe, setShowIframe] = useState(null); // To track which file's iframe to show
  const [sameSubCaderModal, setSameSubCaderModal] = useState(false);

  useEffect(() => {
    if (applicationDetails) {
      setFormData({
        exServiceman: applicationDetails?.exServiceman || "",
        exServicemanDefenseService:
          applicationDetails?.exServicemanDefenseService || "",
        exServicemanServiceStatus:
          applicationDetails?.exServicemanServiceStatus || "",
        exServicemanJoiningDate:
          applicationDetails?.exServicemanJoiningDate || "",
        exServicemanRetirementDate:
          applicationDetails?.exServicemanRetirementDate || "",
        exServicemanDeclaration:
          applicationDetails?.exServicemanDeclaration || "",
        exServicemanTotalServicePeriod:
          applicationDetails?.exServicemanTotalServicePeriod || "",
        // exServicemanAvailedReservation: applicationDetails?.exServicemanAvailedReservation || '',
        exServicemanAppliedForCivilEmployment:
          applicationDetails?.exServicemanAppliedForCivilEmployment || "",
        // exServicemanTotalServicePeriodContinuing: applicationDetails?.exServicemanTotalServicePeriodContinuing || "",
        exServicemanTotalServicePeriodContinuingDuration:
          applicationDetails?.exServicemanTotalServicePeriodContinuingDuration ||
          "",
        exServicemenFiles: applicationDetails?.exServicemenFiles ||  [{ file: null, name: "", verified: false }], // Array of files
      });
    }
  }, []);

  useEffect(() => {
    handelApplicationDetailsChange(formData);
  }, [formData]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const checkErrorFn = (camelCaseKey, immediateValue, index = null) => {
    let errCount = 0;
    const newErrors = { ...fieldErrors };
    const isEmpty =
      immediateValue === "" ||
      immediateValue === null ||
      (typeof immediateValue === "boolean" ? false : !immediateValue?.trim?.());

      if (isEmpty) {
        if (index !== null) {
          newErrors[`${camelCaseKey}_${index}`] = {
            errors: ["This field is required."],
            touched: true,
          };
        } else {
          newErrors[camelCaseKey] = { errors: ["This field is required."], touched: true };
        }
      }
    // Check for required fields
    if (!immediateValue) {
      errCount++;
      setFieldErrors((prevState) => ({
        ...prevState,
        [camelCaseKey]: {
          errors: ["This field is required."],
          touched: true,
        },
      }));
    } else {
      switch (camelCaseKey) {
        case "exServicemanJoiningDate":
        case "exServicemanRetirementDate":
          const regexDate = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
          const isValidDate = regexDate.test(immediateValue);
          if (!isValidDate) {
            errCount++;
            setFieldErrors((prevState) => ({
              ...prevState,
              [camelCaseKey]: {
                errors: ["Enter a valid date in the format YYYY-MM-DD."],
                touched: true,
              },
            }));
          }
          break;

          case "exServicemenFileName":
            if (index !== null) {
              newErrors[`exServicemenFileName_${index}`] = {
                errors: isEmpty ? ["File name is required."] : [],
                touched: true,
              };
            }
            break;
         
        default:
          setFieldErrors((prevState) => ({
            ...prevState,
            [camelCaseKey]: {
              errors: [],
              touched: true,
            },
          }));
          break;
      }
    }

    if (errCount === 0) {
      setFieldErrors((prevState) => ({
        ...prevState,
        [camelCaseKey]: {
          errors: [],
          touched: true,
        },
      }));
    }
  };

  const advertisementClosingDate = new Date(closingDate);

  const calculateServicePeriodDischarge = (dischargeDate) => {
    if (!dischargeDate) return;

    const endDate = new Date(dischargeDate);
    const startDate = new Date(formData?.exServicemanJoiningDate);

    const totalYears = endDate.getFullYear() - startDate.getFullYear();
    const totalMonths = endDate.getMonth() - startDate.getMonth();
    const totalDays = endDate.getDate() - startDate.getDate();

    let years = totalYears;
    let months = totalMonths;
    let days = totalDays;

    if (days < 0) {
      months -= 1;
      days += new Date(endDate.getFullYear(), endDate.getMonth(), 0).getDate();
    }

    if (months < 0) {
      years -= 1;
      months += 12;
    }

    const totalServicePeriod = `${years} Years, ${months} Months, ${days} Days`;
    console.log("totalServicePeriod", totalServicePeriod);
    const totalMonth = years * 12 + months + Math.floor(days / 30);

    setFormData((prevData) => ({
      ...prevData,
      exServicemanTotalServicePeriod: totalServicePeriod,
    }));

    if (totalMonth <= 6) {
      setSameSubCaderModal(true);
      setFormData((prevFormData) => ({
        ...prevFormData,
        exServiceman: "No",
        exServicemanDefenseService: "",
        exServicemanServiceStatus: "",
        exServicemanJoiningDate: "",
        exServicemanRetirementDate: "",
        exServicemanTotalServicePeriod: "",
        exServicemanAppliedForCivilEmployment: "",
        exServicemanDeclaration: false,
        // exServicemanTotalServicePeriodContinuing: "",
        exServicemanTotalServicePeriodContinuingDuration: "",
      }));
    }
  };

  function dateDifference(date2) {
    console.log({ date2 });
    let date1 = advertisementClosingDate;
    let retirementDate = new Date(date2);

    if (date1 > retirementDate) {
      [date1, retirementDate] = [retirementDate, date1];
    }

    let years = retirementDate.getFullYear() - date1.getFullYear();
    let months = retirementDate.getMonth() - date1.getMonth();
    let days = retirementDate.getDate() - date1.getDate();

    if (days < 0) {
      months--;
      const prevMonth = new Date(
        retirementDate.getFullYear(),
        retirementDate.getMonth(),
        0
      );
      days += prevMonth.getDate();
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    const totalServicePeriod = `${years} Years, ${months} Months, ${days} Days`;
    console.log("totalServicePeriod", totalServicePeriod);

    ///////////////////////////////////////////////////////////////////////

    const endDate = new Date(formData?.exServicemanRetirementDate);
    const startDate = new Date(formData?.exServicemanJoiningDate);

    const totalYears = endDate.getFullYear() - startDate.getFullYear();
    const totalMonths = endDate.getMonth() - startDate.getMonth();
    const totalDays = endDate.getDate() - startDate.getDate();

    let year = totalYears;
    let month = totalMonths;
    let day = totalDays;

    if (days < 0) {
      months -= 1;
      days += new Date(endDate.getFullYear(), endDate.getMonth(), 0).getDate();
    }

    if (months < 0) {
      years -= 1;
      months += 12;
    }

    const totalServicePeriodContinue = `${year} Years, ${month} Months, ${day} Days`;
    console.log("totalServicePeriodContinue", totalServicePeriodContinue);
    const totalMonth = year * 12 + month + Math.floor(days / 30);
    console.log("totalMonth", totalMonth);

    // setFormData((prevData) => ({
    //     ...prevData,
    //     // exServicemanTotalServicePeriodContinuing: totalServicePeriod,
    // }));

    if (totalMonth <= 6 || years > 0 || months >= 6) {
      setSameSubCaderModal(true);
      setFormData((prevFormData) => ({
        ...prevFormData,
        exServiceman: "No",
        exServicemanDefenseService: "",
        exServicemanServiceStatus: "",
        exServicemanJoiningDate: "",
        exServicemanRetirementDate: "",
        exServicemanTotalServicePeriod: "",
        exServicemanAppliedForCivilEmployment: "",
        exServicemanDeclaration: false,
        // exServicemanTotalServicePeriodContinuing: "",
        exServicemanTotalServicePeriodContinuingDuration: "",
      }));
    }
  }

  function totalServicePeriod(joiningDate) {
    if (joiningDate) {
      console.log("joiningDate", joiningDate);
      let joinDate = new Date(joiningDate);
      let date1 = advertisementClosingDate;

      console.log("allDate", { joinDate }, { date1 });

      if (date1 > joinDate) {
        [date1, joinDate] = [joinDate, date1];
      }

      let years = joinDate.getFullYear() - date1.getFullYear();
      let months = joinDate.getMonth() - date1.getMonth();
      let days = joinDate.getDate() - date1.getDate();

      if (days < 0) {
        months--;
        const prevMonth = new Date(
          joinDate.getFullYear(),
          joinDate.getMonth(),
          0
        );
        days += prevMonth.getDate();
      }

      if (months < 0) {
        years--;
        months += 12;
      }

      const totalServicePeriod = `${years} Years, ${months} Months, ${days} Days`;
      console.log("totalServicePeriod", totalServicePeriod);

      setFormData((prevData) => ({
        ...prevData,
        exServicemanTotalServicePeriodContinuingDuration: totalServicePeriod,
      }));
    }
  }

  // Handler for adding a new file
  const addFile = () => {
    setFormData((prevData) => ({
      ...prevData,
      exServicemenFiles: [
        ...prevData.exServicemenFiles,
        { file: null, name: "", verified: false },
      ],
    }));
  };

  const removeFile = (index) => {
    const updatedFiles = [...formData.exServicemenFiles];
    updatedFiles.splice(index, 1);
    setFormData((prevData) => ({
      ...prevData,
      exServicemenFiles: updatedFiles,
    }));
    // Remove any associated errors
    const updatedErrors = { ...fieldErrors };
    delete updatedErrors[`exServicemenFileName_${index}`];
    delete updatedErrors[`exServicemenFiles_${index}`];
    setFieldErrors(updatedErrors);
  };

  // Handler for file input change
  const handleFileChange = async (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const isPDF = file.type === "application/pdf";
      const isUnder2MB = file.size <= 2 * 1024 * 1024;
      if (!isPDF) {
        toast.warn("Invalid file type. Only PDF files are allowed.");
        return;
      }
    
      const fileUrl = await AWSUpload(file); // Assuming UploadPdf returns a URL
      if (fileUrl) {
        const updatedFiles = [...formData.exServicemenFiles];
        updatedFiles[index] = {
          ...updatedFiles[index],
          file: fileUrl,
          verified: false,
        };
        setFormData((prevData) => ({
          ...prevData,
          exServicemenFiles: updatedFiles,
        }));
        // Reset verification status
        setFieldErrors((prevErrors) => ({
          ...prevErrors,
          [`exServicemenFiles_${index}`]: {
            errors: [],
            touched: true,
          },
        }));
      }
    }
  };

  // Handler for name input change
  const handleFileNameChange = (e, index) => {
    const { value } = e.target;
    const updatedFiles = [...formData.exServicemenFiles];
    updatedFiles[index].name = value;
    setFormData((prevData) => ({
      ...prevData,
      exServicemenFiles: updatedFiles,
    }));
    checkErrorFn("exServicemenFileName", value, index);
  };

  // Handler to open the iframe modal for verification
  const handleOpenVerificationModal = (index) => {
    setShowIframe(index);
  };

  // Handler to confirm verification
  const handleConfirmVerification = () => {
    if (showIframe !== null) {
      const updatedFiles = [...formData.exServicemenFiles];
      updatedFiles[showIframe].verified = true;
      setFormData((prevData) => ({
        ...prevData,
        exServicemenFiles: updatedFiles,
      }));
      setFieldErrors((prevErrors) => ({
        ...prevErrors,
        [`exServicemenFiles_${showIframe}`]: {
          errors: [],
          touched: true,
        },
      }));
      setShowIframe(null); // Close the modal after verification
      toast.success("File verified successfully!");
    }
  };

  return (
    <>
      <Row>
        <Col xs={12} md={12}>
          <div
            style={{ fontFamily: "'Roboto', sans-serif", color: "brown" }}
            className="fw-bolder mb-3"
          >
            <ol className="mt-2">
              <li>
                1. In case the applicant/candidate is currently serving in the
                defense forces, they may apply under the Ex-Serviceman category
                only if their total service period is six months or more and
                they can provide proof of discharge or retirement within six
                months from the last date of the advertisement. The total
                experience will be calculated as of the last date of application
                submission.
              </li>
              <li>
                2. In case the applicant has already availed of a post under the
                Ex-Serviceman category, he/she will not be eligible for any
                benefits under the Ex-Serviceman category. However, he/she may
                apply under his/her own category.
              </li>
            </ol>
          </div>
        </Col>
        <Col xs={window.innerWidth >= 793 ? 4 : 12} md={5}>
          <div className="mb-1">
            <label className="form-label inputBoxHeadForm" style={style.label}>
              Are you an applicant under Ex-Serviceman Category?
              <span className="mx-1 text-danger">*</span>
            </label>
            <select
              // className="form-control"
              name="exServiceman"
              value={formData.exServiceman}
              onChange={(e) => {
                handleInputChange(e);
                checkErrorFn("exServiceman", e.target.value);
                if (e.target.value === "No") {
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    exServicemanDefenseService: "",
                    exServicemanServiceStatus: "",
                    exServicemanJoiningDate: "",
                    exServicemanRetirementDate: "",
                    exServicemanTotalServicePeriod: "",
                    exServicemanAppliedForCivilEmployment: "",
                    exServicemanDeclaration: false,
                    // exServicemanTotalServicePeriodContinuing: "",
                    exServicemanTotalServicePeriodContinuingDuration: "",
                    exServicemenFiles:[{ file: null, name: "", verified: false }],
                  }));
                }
              }}
              onBlur={() =>
                checkErrorFn("exServiceman", formData["exServiceman"])
              }
              required
              style={
                fieldErrors?.["exServiceman"]?.errors?.length > 0 &&
                fieldErrors?.["exServiceman"]?.touched
                  ? { ...style.input, ...style.errorBox }
                  : style.input
              }
            >
              <option value="">Select</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            {fieldErrors?.["exServiceman"]?.errors?.length > 0 &&
              fieldErrors?.["exServiceman"]?.touched &&
              fieldErrors?.["exServiceman"]?.errors.map((err) => (
                <span className="errorPresent" style={style.errorSpan}>
                  {err}
                  <br />
                </span>
              ))}
          </div>
        </Col>

        {formData.exServiceman === "Yes" && (
          <>
            <Col xs={window.innerWidth >= 793 ? 4 : 12} md={4}>
              <div className="mb-1">
                <label
                  className="form-label inputBoxHeadForm"
                  htmlFor="exServicemanDefenseService"
                  style={style.label}
                >
                  Defence Service Wherein Served/Serving
                  <span className="mx-1 text-danger">*</span>
                </label>
                <select
                  // className="form-control"
                  id="exServicemanDefenseService"
                  name="exServicemanDefenseService"
                  value={formData.exServicemanDefenseService}
                  onChange={(e) => {
                    handleInputChange(e);
                    checkErrorFn("exServicemanDefenseService", e.target.value);
                  }}
                  onBlur={() =>
                    checkErrorFn(
                      "exServicemanDefenseService",
                      formData["exServicemanDefenseService"]
                    )
                  }
                  required
                  style={
                    fieldErrors?.["exServicemanDefenseService"]?.errors
                      ?.length > 0 &&
                    fieldErrors?.["exServicemanDefenseService"]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                >
                  <option value="">Select</option>
                  <option value="Army">Army</option>
                  <option value="Navy">Navy</option>
                  <option value="Air Force">Air Force</option>
                </select>
                {fieldErrors?.["exServicemanDefenseService"]?.errors?.length >
                  0 &&
                  fieldErrors?.["exServicemanDefenseService"]?.touched &&
                  fieldErrors?.["exServicemanDefenseService"]?.errors.map(
                    (err) => (
                      <span className="errorPresent" style={style.errorSpan}>
                        {err}
                        <br />
                      </span>
                    )
                  )}
              </div>
            </Col>

            <Col xs={window.innerWidth >= 793 ? 4 : 12} md={3}>
              <div className="mb-1">
                <label
                  className="form-label inputBoxHeadForm"
                  htmlFor="exServicemanServiceStatus"
                  style={style.label}
                >
                  Status of Defence Service
                  <span className="mx-1 text-danger">*</span>
                </label>
                <select
                  // className="form-control"
                  id="exServicemanServiceStatus"
                  name="exServicemanServiceStatus"
                  value={formData.exServicemanServiceStatus}
                  onChange={(e) => {
                    handleInputChange(e);
                    checkErrorFn("exServicemanServiceStatus", e.target.value);
                  }}
                  onBlur={() =>
                    checkErrorFn(
                      "exServicemanServiceStatus",
                      formData["exServicemanServiceStatus"]
                    )
                  }
                  required
                  style={
                    fieldErrors?.["exServicemanServiceStatus"]?.errors?.length >
                      0 && fieldErrors?.["exServicemanServiceStatus"]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                >
                  <option value="">Select</option>
                  <option value="Continuing">Continuing</option>
                  <option value="Discharge">Discharged</option>
                </select>
                {fieldErrors?.["exServicemanServiceStatus"]?.errors?.length >
                  0 &&
                  fieldErrors?.["exServicemanServiceStatus"]?.touched &&
                  fieldErrors?.["exServicemanServiceStatus"]?.errors.map(
                    (err) => (
                      <span className="errorPresent" style={style.errorSpan}>
                        {err}
                        <br />
                      </span>
                    )
                  )}
              </div>
            </Col>

            <Col xs={window.innerWidth >= 793 ? 4 : 12} md={5}>
              <div className="mb-1">
                <label
                  className="form-label inputBoxHeadForm"
                  htmlFor="exServicemanJoiningDate"
                  style={style.label}
                >
                  Joining Date of Service
                  <span className="mx-1 text-danger">*</span>
                </label>
                <input
                  type="date"
                  id="exServicemanJoiningDate"
                  name="exServicemanJoiningDate"
                  value={formData.exServicemanJoiningDate || ""}
                  onChange={(e) => {
                    handleInputChange(e);
                    checkErrorFn("exServicemanJoiningDate", e.target.value);
                    if (
                      formData.exServicemanServiceStatus === "Discharge" &&
                      formData.exServicemanRetirementDate
                    ) {
                      calculateServicePeriodDischarge(
                        formData.exServicemanRetirementDate
                      );
                    }
                    if (
                      formData.exServicemanServiceStatus === "Continuing" &&
                      formData.exServicemanRetirementDate
                    ) {
                      dateDifference(formData.exServicemanRetirementDate);
                    }
                    if (
                      formData.exServicemanServiceStatus === "Continuing" &&
                      e.target.value
                    ) {
                      totalServicePeriod(e.target.value);
                    }
                  }}
                  onBlur={() =>
                    checkErrorFn(
                      "exServicemanJoiningDate",
                      formData["exServicemanJoiningDate"]
                    )
                  }
                  required
                  style={
                    fieldErrors?.["exServicemanJoiningDate"]?.errors?.length >
                      0 && fieldErrors?.["exServicemanJoiningDate"]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                  max={new Date().toISOString().split("T")[0]}
                  defaultValue={""}
                />
                {fieldErrors?.["exServicemanJoiningDate"]?.errors?.length > 0 &&
                  fieldErrors?.["exServicemanJoiningDate"]?.touched &&
                  fieldErrors?.["exServicemanJoiningDate"]?.errors.map(
                    (err) => (
                      <span className="errorPresent" style={style.errorSpan}>
                        {err}
                        <br />
                      </span>
                    )
                  )}
              </div>
            </Col>

            <Col xs={window.innerWidth >= 793 ? 4 : 12} md={4}>
              <div className="mb-1">
                <label
                  className="form-label inputBoxHeadForm"
                  htmlFor="exServicemanRetirementDate"
                  style={style.label}
                >
                  Date of Discharge/Retirement
                  <span className="mx-1 text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="date"
                  id="exServicemanRetirementDate"
                  name="exServicemanRetirementDate"
                  value={formData.exServicemanRetirementDate}
                  onChange={(e) => {
                    handleInputChange(e);
                    checkErrorFn("exServicemanRetirementDate", e.target.value);
                    if (formData.exServicemanServiceStatus === "Continuing") {
                      dateDifference(e.target.value);
                    }
                    if (formData.exServicemanServiceStatus === "Discharge") {
                      calculateServicePeriodDischarge(e.target.value);
                    }
                  }}
                  onBlur={() =>
                    checkErrorFn(
                      "exServicemanRetirementDate",
                      formData["exServicemanJoiningDate"]
                    )
                  }
                  required
                  style={
                    fieldErrors?.["exServicemanRetirementDate"]?.errors
                      ?.length > 0 &&
                    fieldErrors?.["exServicemanRetirementDate"]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                  max={
                    formData.exServicemanServiceStatus === "Discharge"
                      ? new Date().toISOString().split("T")[0]
                      : ""
                  }
                  min={
                    formData.exServicemanServiceStatus === "Continuing"
                      ? new Date().toISOString().split("T")[0]
                      : ""
                  }
                />
                {fieldErrors?.["exServicemanRetirementDate"]?.errors?.length >
                  0 &&
                  fieldErrors?.["exServicemanRetirementDate"]?.touched &&
                  fieldErrors?.["exServicemanRetirementDate"]?.errors.map(
                    (err) => (
                      <span className="errorPresent" style={style.errorSpan}>
                        {err}
                        <br />
                      </span>
                    )
                  )}
              </div>
            </Col>

            {formData.exServicemanServiceStatus === "Discharge" && (
              <>
                <Col xs={window.innerWidth >= 793 ? 4 : 12} md={3}>
                  <div className="mb-1">
                    <label
                      className="form-label inputBoxHeadForm"
                      htmlFor="exServicemanTotalServicePeriod"
                      style={style.label}
                    >
                      Total Service Period
                      <span className="mx-1 text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      id="exServicemanTotalServicePeriod"
                      name="exServicemanTotalServicePeriod"
                      value={formData.exServicemanTotalServicePeriod}
                      onChange={(e) => {
                        handleInputChange(e);
                        checkErrorFn(
                          "exServicemanTotalServicePeriod",
                          e.target.value
                        );
                      }}
                      onBlur={() =>
                        checkErrorFn(
                          "exServicemanTotalServicePeriod",
                          formData["exServicemanTotalServicePeriod"]
                        )
                      }
                      required
                      style={
                        fieldErrors?.["exServicemanTotalServicePeriod"]?.errors
                          ?.length > 0 &&
                        fieldErrors?.["exServicemanTotalServicePeriod"]?.touched
                          ? { ...style.input, ...style.errorBox }
                          : style.input
                      }
                      min="0"
                    />
                    {fieldErrors?.["exServicemanTotalServicePeriod"]?.errors
                      ?.length > 0 &&
                      fieldErrors?.["exServicemanTotalServicePeriod"]
                        ?.touched &&
                      fieldErrors?.[
                        "exServicemanTotalServicePeriod"
                      ]?.errors.map((err) => (
                        <span className="errorPresent" style={style.errorSpan}>
                          {err}
                          <br />
                        </span>
                      ))}
                  </div>
                </Col>
              </>
            )}

            {formData.exServicemanServiceStatus === "Continuing" && (
              <>
                <Col xs={window.innerWidth >= 793 ? 4 : 12} md={3}>
                  <div className="mb-1">
                    <label
                      className="form-label inputBoxHeadForm"
                      htmlFor="exServicemanTotalServicePeriodContinuingDuration"
                      style={style.label}
                    >
                      Total Service Period
                      <span className="mx-1 text-danger">*</span>
                    </label>
                    <input
                      disabled
                      className="form-control"
                      type="text"
                      id="exServicemanTotalServicePeriodContinuingDuration"
                      name="exServicemanTotalServicePeriodContinuingDuration"
                      value={
                        formData.exServicemanTotalServicePeriodContinuingDuration
                      }
                      onChange={(e) => {
                        handleInputChange(e);
                        checkErrorFn(
                          "exServicemanTotalServicePeriodContinuingDuration",
                          e.target.value
                        );
                      }}
                      onBlur={() =>
                        checkErrorFn(
                          "exServicemanTotalServicePeriodContinuingDuration",
                          formData[
                            "exServicemanTotalServicePeriodContinuingDuration"
                          ]
                        )
                      }
                      required
                      style={
                        fieldErrors?.[
                          "exServicemanTotalServicePeriodContinuingDuration"
                        ]?.errors?.length > 0 &&
                        fieldErrors?.[
                          "exServicemanTotalServicePeriodContinuingDuration"
                        ]?.touched
                          ? { ...style.input, ...style.errorBox }
                          : style.input
                      }
                    />
                    {fieldErrors?.[
                      "exServicemanTotalServicePeriodContinuingDuration"
                    ]?.errors?.length > 0 &&
                      fieldErrors?.[
                        "exServicemanTotalServicePeriodContinuingDuration"
                      ]?.touched &&
                      fieldErrors?.[
                        "exServicemanTotalServicePeriodContinuingDuration"
                      ]?.errors.map((err) => (
                        <span className="errorPresent" style={style.errorSpan}>
                          {err}
                          <br />
                        </span>
                      ))}
                  </div>
                  <span
                    className="fw-bold text-nowrap"
                    style={{
                      fontSize: "0.8em",
                      verticalAlign: "baseline",
                      color: "brown",
                    }}
                  >
                    (Date as of {formatDate(closingDate)})
                  </span>
                </Col>

                {/* ////////////////// */}

                {/* <Col xs={window.innerWidth >= 793 ? 4 : 12} md={5}>
                                    <div className="mb-1">
                                        <label className="form-label inputBoxHeadForm" htmlFor="exServicemanTotalServicePeriodContinuing" style={style.label}>
                                            Duration of Adv. Closing Date & Retirement Date<span className="mx-1 text-danger">*</span>
                                        </label>
                                        <input
                                            disabled
                                            className="form-control"
                                            type="text"
                                            id="exServicemanTotalServicePeriodContinuing"
                                            name="exServicemanTotalServicePeriodContinuing"
                                            value={formData.exServicemanTotalServicePeriodContinuing}
                                            onChange={(e) => {
                                                handleInputChange(e);
                                                checkErrorFn('exServicemanTotalServicePeriodContinuing', e.target.value);
                                            }}
                                            onBlur={() => checkErrorFn('exServicemanTotalServicePeriodContinuing', formData['exServicemanTotalServicePeriodContinuing'])}
                                            required
                                            style={
                                                fieldErrors?.['exServicemanTotalServicePeriodContinuing']?.errors?.length > 0 && fieldErrors?.['exServicemanTotalServicePeriodContinuing']?.touched
                                                    ? { ...style.input, ...style.errorBox }
                                                    : style.input
                                            }
                                        />
                                        {fieldErrors?.['exServicemanTotalServicePeriodContinuing']?.errors?.length > 0 && fieldErrors?.['exServicemanTotalServicePeriodContinuing']?.touched &&
                                            fieldErrors?.['exServicemanTotalServicePeriodContinuing']?.errors.map((err) => (
                                                <span className="errorPresent" style={style.errorSpan}>
                                                    {err}
                                                    <br />
                                                </span>
                                            ))
                                        }
                                    </div>
                                </Col> */}

                {/* <span
                                    className="fw-bold text-nowrap"
                                    style={{
                                        fontSize: "0.8em",
                                        verticalAlign: "baseline",
                                        color: "brown"
                                    }}
                                >
                                    (Date as of {formatDate(closingDate)})
                                </span> */}
              </>
            )}

            <Col xs={window.innerWidth >= 793 ? 12 : 12} md={12}>
              <div className="mb-1">
                <label
                  className="form-label inputBoxHeadForm"
                  htmlFor="exServicemanAppliedForCivilEmployment"
                  style={style.label}
                >
                  Have you availed Ex-Serviceman reservation earlier in any Govt
                  Organization/Autonomous Bodies/PSU against any regular post?
                  <span className="mx-1 text-danger">*</span>
                </label>
                <select
                  id="exServicemanAppliedForCivilEmployment"
                  name="exServicemanAppliedForCivilEmployment"
                  value={formData.exServicemanAppliedForCivilEmployment}
                  onChange={(e) => {
                    const value = e.target.value;
                    handleInputChange(e);
                    checkErrorFn(
                      "exServicemanAppliedForCivilEmployment",
                      value
                    );
                    if (value === "Yes") {
                      // Show the modal
                      setExServiceModal(true);

                      // Clear the related fields
                      setFormData((prevFormData) => ({
                        ...prevFormData,
                        exServiceman: "No",
                        exServicemanDefenseService: "",
                        exServicemanServiceStatus: "",
                        exServicemanJoiningDate: "",
                        exServicemanRetirementDate: "",
                        exServicemanTotalServicePeriod: "",
                        exServicemanAppliedForCivilEmployment: "",
                        exServicemenFiles: [{ file: null, name: "", verified: false }],
                      }));
                    }
                  }}
                  onBlur={() =>
                    checkErrorFn(
                      "exServicemanAppliedForCivilEmployment",
                      formData["exServicemanAppliedForCivilEmployment"]
                    )
                  }
                  required
                  style={
                    fieldErrors?.["exServicemanAppliedForCivilEmployment"]
                      ?.errors?.length > 0 &&
                    fieldErrors?.["exServicemanAppliedForCivilEmployment"]
                      ?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                {fieldErrors?.["exServicemanAppliedForCivilEmployment"]?.errors
                  ?.length > 0 &&
                  fieldErrors?.["exServicemanAppliedForCivilEmployment"]
                    ?.touched &&
                  fieldErrors?.[
                    "exServicemanAppliedForCivilEmployment"
                  ]?.errors.map((err) => (
                    <span className="errorPresent" style={style.errorSpan}>
                      {err}
                      <br />
                    </span>
                  ))}
              </div>
            </Col>

            {/* File Upload Section */}
            <Col xs={12} md={12} id="exservicemenFileUpload">
              <div className="mb-3">
              
                  <div className="d-flex">
                    <label
                      className="form-label inputBoxHeadForm"
                      style={style.label}
                    >
                      Upload Documents
                      <span className="mx-1 text-danger">*</span>
                    </label>

                    <div
                      style={{
                        fontSize: "12px",
                        color: "brown",
                        fontWeight: "bold",
                      }}
                    >
                      (Only PDF files that are under 2 MB in size are accepted.)
                    </div>
                  </div>
              

                {formData?.exServicemenFiles.map((fileObj, index) => (
                  <Row key={index} className="align-items-center mb-2">
                    {/* File Upload & Change Button */}
                    <Col xs={12} md={3} >
<div  className="d-flex flex-column">

                      <input
                        type="file"
                        accept=".pdf"
                        onChange={(e) => handleFileChange(e, index)}
                        style={{ display: "none" }}
                        id={`exServicemenFiles_input_${index}`}
                      />
                      <button
                        type="button"
                        onClick={() =>
                          document
                            .getElementById(`exServicemenFiles_input_${index}`)
                            .click()
                        }
                        onBlur={() =>
                          checkErrorFn("exServicemenFiles", fileObj.file, index)
                        }
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          height: "37px",
                          fontSize: "12px",
                          cursor: "pointer",
                          border: "none",
                          backgroundColor:"#921d1e",
                            // fieldErrors?.[`exServicemenFiles_${index}`]?.errors
                            //   ?.length > 0
                            //   ? "#921d1e"
                            //   : "#f0f0f0",
                          color:"#fff",
                            // fieldErrors?.[`exServicemenFiles_${index}`]?.errors
                            //   ?.length > 0
                            //   ? "#fff"
                            //   : "#333",
                        }}
                      >
                        {/* <FaPlus /> */}
                        <span className="ps-1">Upload File</span>
                      </button>
                      {fieldErrors?.[`exServicemenFiles_${index}`]?.errors?.map(
                        (err, errIdx) => (
                          <span
                            key={errIdx}
                            className="errorPresent"
                            style={style.errorSpan}
                          >
                            {err}
                          </span>
                        )
                      )}
</div>
                    </Col>

                    {/* File Name Input */}
                    <Col xs={12} md={4}>
                      <input
                        type="text"
                        placeholder="Enter File Name"
                        value={fileObj.name}
                        onChange={(e) => handleFileNameChange(e, index)}
                        onBlur={() =>
                          checkErrorFn(
                            "exServicemenFileName",
                            fileObj.name,
                            index
                          )
                        }
                        className="form-control"
                        style={
                          fieldErrors?.[`exServicemenFileName_${index}`]?.errors
                            ?.length > 0
                            ? { ...style.input, ...style.errorBox }
                            : style.input
                        }
                      />
                      {fieldErrors?.[`exServicemenFileName_${index}`]?.errors
                        ?.length > 0 &&
                        fieldErrors?.[
                          `exServicemenFileName_${index}`
                        ]?.errors.map((err, errIdx) => (
                          <span
                            key={errIdx}
                            className="errorPresent"
                            style={style.errorSpan}
                          >
                            {err}
                            <br />
                          </span>
                        ))}
                    </Col>

                    {/* File Actions: Preview, Verify, Delete */}
                    <Col xs={12} md={5} className="d-flex align-items-center">
                      {fileObj.file && (
                        <>
                          {/* PDF Preview */}
                          <img
                            src={pdfIcon}
                            alt="PDF Preview"
                            style={{ width: "40px", cursor: "pointer" }}
                            onClick={() => setShowIframe(index)}
                            className="me-2"
                          />

                          {/* Verify or Verified Badge */}
                          {!fileObj.verified ? (
                            <Button
                              size="sm"
                              //   variant="outline-success"
                              onClick={() => handleOpenVerificationModal(index)}
                              className="me-2"
                            >
                              Verify
                            </Button>
                          ) : (
                            <Badge
                              bg="success"
                              className="d-flex align-items-center me-2"
                            >
                              <FaCheckCircle size={"18"} className="me-1" />
                              Verified
                            </Badge>
                          )}

                          {/* Eye Icon */}
                          <Button
                            size="sm"
                            variant="outline"
                            onClick={() => handleOpenVerificationModal(index)}
                            className="me-2"
                          >
                            <IoEyeOutline size={"20"} />
                          </Button>

                          {/* Delete Icon */}
                          <Button
                            size="sm"
                            variant="outline"
                            onClick={() => removeFile(index)}
                          >
                            <MdDeleteOutline size={"20"} />
                          </Button>
                        </>
                      )}
                    </Col>
                  </Row>
                ))}

                {/* Add File Button */}
                <div className="text-end">
                  <Button
                    style={{ backgroundColor: "brown", borderColor: "brown" }}
                    onClick={addFile}
                  >
                    Add File
                  </Button>
                </div>
              </div>
            </Col>

            <div style={{ display: "flex", marginTop: "30px" }}>
              <input
                type="checkbox"
                id="declaration-checkbox"
                name="exServicemanDeclaration"
                checked={formData?.exServicemanDeclaration}
                onChange={(e) => {
                  handleInputChange(e);
                }}
                onBlur={() =>
                  checkErrorFn(
                    "exServicemanDeclaration",
                    formData["exServicemanDeclaration"]
                  )
                }
                style={{ marginRight: "10px" }}
              />
              <label
                htmlFor="declaration-checkbox"
                className="fw-bold"
                style={{
                  fontSize: "14px",
                  lineHeight: "1.5",
                  fontFamily: "'Roboto', sans-serif",
                  color: "black",
                }}
              >
                I do hereby declare that I shall submit date-wise details of my
                application (s) for various vacancy (ies), for which I have
                applied for, at the time of Document Verification, if
                shortlisted.
              </label>
            </div>
            {fieldErrors?.["exServicemanDeclaration"]?.errors?.length > 0 &&
              fieldErrors?.["exServicemanDeclaration"]?.touched &&
              fieldErrors?.["exServicemanDeclaration"]?.errors.map((err) => (
                <span className="errorPresent" style={style.errorSpan}>
                  {err}
                  <br />
                </span>
              ))}

            {/* <Col xs={window.innerWidth >= 793 ? 5 : 12} md={5}>
                        <div className="mb-1">
                            <label className="form-label inputBoxHeadForm" htmlFor="exServicemanAvailedReservation" style={style.label}>
                                Have you applied any civil employment against Ex-Serviceman Category?<span className="mx-1 text-danger">*</span>
                            </label>
                            <select
                                // className="form-control"
                                id="exServicemanAvailedReservation"
                                name="exServicemanAvailedReservation"
                                value={formData.exServicemanAvailedReservation}
                                onChange={(e) => {
                                    handleInputChange(e);
                                    checkErrorFn('exServicemanAvailedReservation', e.target.value);
                                }}
                                onBlur={() => checkErrorFn('exServicemanAvailedReservation', formData['exServicemanAvailedReservation'])}
                                required
                                style={
                                    fieldErrors?.['exServicemanAvailedReservation']?.errors?.length > 0 && fieldErrors?.['exServicemanAvailedReservation']?.touched
                                        ? { ...style.input, ...style.errorBox }
                                        : style.input
                                }
                            >
                                <option value="">Select</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                            {fieldErrors?.['exServicemanAvailedReservation']?.errors?.length > 0 && fieldErrors?.['exServicemanAvailedReservation']?.touched &&
                                fieldErrors?.['exServicemanAvailedReservation']?.errors.map((err) => (
                                    <span className="errorPresent" style={style.errorSpan}>
                                        {err}
                                        <br />
                                    </span>
                                ))
                            }
                        </div>
                    </Col> */}
          </>
        )}
      </Row>

      {exServiceModal && (
        <Modal
          show={exServiceModal}
          onHide={() => setExServiceModal(false)}
          centered
        >
          <Modal.Header style={{ background: "#921D1E", color: "white" }}>
            <div className="d-flex align-items-center justify-content-center w-100">
              <img src={waringSign} alt="warn" />
            </div>
          </Modal.Header>
          <Modal.Body>
            <h2
              style={{
                color: "#921D1E",
                fontSize: "28px",
                fontFamily: "Roboto",
                textAlign: "center",
              }}
            >
              Warning !
            </h2>
            <p
              style={{
                fontSize: "16px",
                marginTop: "20px",
                fontFamily: "Roboto",
                textAlign: "center",
              }}
            >
              You are not eligible as you availed Ex-Serviceman reservation
              earlier in any Govt Organization/Autonomous Bodies/PSU against any
              regular post.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setExServiceModal(false)}
              style={{
                fontSize: "16px",
                fontWeight: "600",
                fontFamily: "Roboto",
                textAlign: "center",
                border: "1px solid #DEBBBB",
                color: "#921D1E",
                background: "#F9F3F4",
              }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {sameSubCaderModal && (
        <Modal
          show={sameSubCaderModal}
          onHide={() => setSameSubCaderModal(false)}
          centered
        >
          <Modal.Header style={{ background: "#921D1E", color: "white" }}>
            <div className="d-flex align-items-center justify-content-center w-100">
              <img src={waringSign} alt="warn" />
            </div>
          </Modal.Header>
          <Modal.Body>
            <h2
              style={{
                color: "#921D1E",
                fontSize: "28px",
                fontFamily: "Roboto",
                textAlign: "center",
              }}
            >
              Warning!
            </h2>
            <p
              style={{
                fontSize: "16px",
                marginTop: "20px",
                fontFamily: "Roboto",
                textAlign: "center",
              }}
            >
              As per the data provided by you, the total duration of your
              service in defense is less than six months. Therefore, you are not
              eligible to apply under the Ex-Serviceman category. You may
              proceed to apply under your respective other category
            </p>
            {/* <Alert variant="warning" className="fw-bolder">
                        Not considered as an Ex-service man.
                    </Alert> */}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setSameSubCaderModal(false)}
              style={{
                fontSize: "14px",
                fontWeight: "600",
                fontFamily: "Roboto",
                textAlign: "center",
                border: "1px solid #DEBBBB",
                color: "#921D1E",
                background: "#F9F3F4",
              }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* Modal for File Preview and Verification */}
      {showIframe !== null && (
        <Modal
          size="lg"
          show={showIframe !== null}
          onHide={() => setShowIframe(null)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Verify Document</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            {formData.exServicemenFiles[showIframe]?.file ? (
              <iframe
                src={formData.exServicemenFiles[showIframe].file}
                width="100%"
                style={{ border: "none", height: "50vh" }}
                title="PDF Viewer"
              />
            ) : (
              <p>No file available for preview.</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            {!formData.exServicemenFiles[showIframe]?.verified && (
              <Button variant="primary" onClick={handleConfirmVerification}>
                Confirm Verification
              </Button>
            )}
            <Button variant="secondary" onClick={() => setShowIframe(null)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default ExServicemen;
